<script setup lang="ts">
const props = defineProps<{
    title: string,
    items: Array<{
        title: string,
        subTitle: string,
        desc: string,
        img: string,
        icon: string,
        btnTxt: string,
        path: string,
    }>
}>();
const device = useDevice();
const activeItem = ref(props.items[0]);
</script>

<template>
    <SectionsBase id="products" class="background">
        <div class="relative container z-1">
            <ChipsDivider>محصولات‌</ChipsDivider>
            <h2>{{ props.title }}</h2>
            <ClientOnly>
                <LazySectionsProductsHomeMobile
                    v-if="!device.isDesktop.value"
                    :items="props.items"
                />
                <LazySectionsProductsHomeDesktop
                    v-else
                    v-model="activeItem"
                    :items="props.items"
                />
            </ClientOnly>
        </div>
    </SectionsBase>
</template>

<style scoped>
@reference "~/assets/css/main.css";

.background {
  @apply
  relative lg:bg-radial lg:from-primary-50/10 lg:to-primary-100
}
.background::before {
    @apply
    content-[''] absolute w-full h-full top-0 right-0 bg-[url('/svg/new/backgrounds/mesh-06.svg')]
    opacity-70 hidden lg:block
}
</style>